export const FLOW_FOLDER_SET = 'FLOW_FOLDER_SET'
